import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppService } from 'app/app.service';

export const TENANT_CONTEXT_HEADER = 'X-Tenant-Guid';

function isBackendRequest(url: string): boolean {
  return url.startsWith('/api') || url.includes('/api/') || url.includes('./api');
}

export const tenantContextInterceptorFn: HttpInterceptorFn = (request, next) => {
  const appService = inject(AppService);
  const tenantId = appService.adminTenantId();

  if (!tenantId || !isBackendRequest(request.url)) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        [TENANT_CONTEXT_HEADER]: tenantId,
      },
    }),
  );
};
